export default __webpack_public_path__ + "static/media/heart_red.1f0560d6.svg";